import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { getDashboardStat } from "service";
import { useUser } from "./useUser";

interface IStatResponse {
  total_vaccinations: number;
  completed_vaccinations: number;
  total_shots: number;
  total_downloads: number;
}

export const useDashboard = () => {
  const navigate = useNavigate();
  const { user } = useUser();

  const {
    data: dashboardStat,
    isLoading: dashboardStatLoading,
    error: dashboardStatError,
    isError,
  } = useQuery<IStatResponse>({
    queryKey: ["dashboardStat"],
    queryFn: async () => {
      const response = await getDashboardStat();
      return response;
    },
    enabled: true,
  });

  return {
    dashboardStat,
    isLoading: dashboardStatLoading,
    error: dashboardStatError,
    navigate,
    user,
  };
};
